import React from "react";
import SoftBox from "../../components/SoftBox";
import SoftTypography from "../../components/SoftTypography";
import { ReactComponent as NoClaimsSvg } from "../../img/claims-no-items.svg";
import { T, CLAIM_FONT } from "./claimTokens";

const NoClaims = ({
  title = "No reviews to claim yet",
  subtitle = "New customer reviews land here the moment they come in. Check back soon.",
}) => (
  <SoftBox
    sx={{
      width: "100%",
      minHeight: "48vh",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      textAlign: "center",
      gap: "6px",
      px: 3,
      py: 6,
    }}
  >
    <SoftBox
      sx={{
        width: "148px",
        height: "auto",
        mb: "14px",
        opacity: 0.9,
        "& svg": { width: "100%", height: "auto", display: "block" },
      }}
    >
      <NoClaimsSvg />
    </SoftBox>

    <SoftTypography
      sx={{
        fontFamily: CLAIM_FONT,
        color: T.ink,
        fontSize: "17px",
        fontWeight: 700,
        letterSpacing: "-0.01em",
      }}
    >
      {title}
    </SoftTypography>
    <SoftTypography
      sx={{
        fontFamily: CLAIM_FONT,
        color: T.muted,
        fontSize: "13.5px",
        fontWeight: 400,
        lineHeight: 1.55,
        maxWidth: "40ch",
      }}
    >
      {subtitle}
    </SoftTypography>
  </SoftBox>
);

export default NoClaims;
